// import React from 'react';
import RHelmet from 'react-helmet';

interface HelmetProps {
  children?: React.ReactNode;
  title?: string;
  metas?: { name: string; content: string }[];
}

export const Helmet: React.FC<HelmetProps> = ({
  children,
  title,
  metas,
}) => (
  <RHelmet>
    {title && (
      <meta
        property="og:title"
        content={title}
      />
    )}
    {title && (
      <title>{title}</title>
    )}
    {metas?.map(({ name, content }) => (
      <meta
        key={name}
        name={name}
        content={content}
      />
    ))}
    {metas?.find((m) => m.name === 'description') && (
      <meta
        property="og:description"
        content={metas.find((m) => m.name === 'description')!.content}
      />
    )}
    {children}
  </RHelmet>
);
